// extracted by mini-css-extract-plugin
export default {"dotButton":"Nav_dotButton__rHnA5","defaultImage":"Nav_defaultImage__RKTBx","hoverImage":"Nav_hoverImage__7GpB5"};